import { render, staticRenderFns } from "./referrer-performance-records.vue?vue&type=template&id=3d87ed98&scoped=true"
import script from "./referrer-performance-records.vue?vue&type=script&lang=js"
export * from "./referrer-performance-records.vue?vue&type=script&lang=js"
import style0 from "./referrer-performance-records.vue?vue&type=style&index=0&id=3d87ed98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87ed98",
  null
  
)

export default component.exports